import { getAnalyticsClient } from '../index';

import { EventMetricsKeys, EventMetricsTypes } from './types';
import UIEventMetrics from './events/ui';
import TrackEventMetrics from './events/track';
import ScreenEventMetrics from './events/screen';
import OperationalEventMetrics from './events/operational';

export * from './types';

export const EventMetrics = {
  screen: ScreenEventMetrics,
  ui: UIEventMetrics,
  track: TrackEventMetrics,
  operational: OperationalEventMetrics,
};

// Analytics Events sent via Analytics Pipeline
// @see https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#event-types
export const sendAnalyticsEvent = (type: EventMetricsTypes, key: EventMetricsKeys): void => {
  const eventMetrics = EventMetrics[type].find((x: any) => x.key === key);
  if (!eventMetrics) return;

  // use type: any to avoid refering to all the weird types from AWC package
  const event: any = eventMetrics?.data;
  if (!event) return;

  const client = getAnalyticsClient();
  if (!client) return;

  switch (type) {
    case EventMetricsTypes.Screen:
      client.sendScreenEvent(event);
      break;
    case EventMetricsTypes.UI:
      client.sendUIEvent(event);
      break;
    case EventMetricsTypes.Track:
      client.sendTrackEvent(event);
      break;
    case EventMetricsTypes.Operatinoal:
      client.sendOperationalEvent(event);
      break;
  }
};
